module.exports = __webpack_public_path__ + "static/img/slide_4.b7e9104.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/careers/slider/slide_4.png
// module id = wzy/
// module chunks = 0